import React from 'react';
import MuiTypography from '@material-ui/core/Typography';

export default function  Typography({children,...rest}) {
    return <MuiTypography variant="h1" component="h2" {...rest}>
    {children}
  </MuiTypography>
}